import {
    Platform
} from "react-native";
import {
    type SelectSheetSearchedDataConstantType,
    type SelectSheetPressType,
    type SelectedItem
} from "./type";

const SELECT_SHEET_OPENER_SELECTOR = "button, a[href], [role=\"button\"], [tabindex]:not([tabindex=\"-1\"])";

const SELECT_SHEET_OPENER_MAX_AGE = 1000;

let lastPress: SelectSheetPressType | undefined;

let pressSubscriberCount = 0;

const getWebDocument = () => {
    if(Platform.OS !== "web" || typeof globalThis.document === "undefined") {
        return undefined;
    }

    return globalThis.document;
};

const getHTMLElement = (node: unknown) => {
    if(typeof HTMLElement === "undefined" || !(node instanceof HTMLElement)) {
        return null;
    }

    return node;
};

const onDocumentClick = (event: MouseEvent) => {
    const target = event.target;

    if(typeof Element === "undefined" || !(target instanceof Element)) {
        lastPress = undefined;

        return;
    }

    const node = getHTMLElement(target.closest(SELECT_SHEET_OPENER_SELECTOR));

    lastPress = node ? {
        time: Date.now(),
        node
    } : undefined;
};

export const getSelectSheetItemKey = (item: SelectedItem) => item.__key;

export const getSelectSheetSearchedData = <T>({
    searchText,
    locale,
    data
}: SelectSheetSearchedDataConstantType<T>) => {
    const query = searchText.toLocaleLowerCase(locale);

    return data.filter((item) => item.__title.toLocaleLowerCase(locale).includes(query));
};

export const subscribeSelectSheetPress = () => {
    const webDocument = getWebDocument();

    if(!webDocument) {
        return undefined;
    }

    pressSubscriberCount += 1;

    if(pressSubscriberCount === 1) {
        webDocument.addEventListener("click", onDocumentClick, true);
    }

    return () => {
        pressSubscriberCount -= 1;

        if(pressSubscriberCount === 0) {
            webDocument.removeEventListener("click", onDocumentClick, true);

            lastPress = undefined;
        }
    };
};

export const focusSelectSheetOpener = () => {
    const webDocument = getWebDocument();

    if(!webDocument) {
        return;
    }

    const activeElement = webDocument.activeElement;

    if(activeElement && activeElement !== webDocument.body) {
        return;
    }

    if(!lastPress || !lastPress.node.isConnected || Date.now() - lastPress.time > SELECT_SHEET_OPENER_MAX_AGE) {
        return;
    }

    lastPress.node.focus({
        preventScroll: true
    });
};
